import React from "react";
import type { EcoConsumptionFuelAreaType } from "../types/EcoConsumptionType";
import styles from "./SpecEcoConsumption.module.scss";
import { useEcoConsumptionLabel } from "../utils/labels";

export const FuelEcoConsumptionArea: React.FC<EcoConsumptionFuelAreaType> = (props) => {
    const { title, subtitle, primary, secondary } = props;
    const [ecoConsumptionNotRelevantLabel] = useEcoConsumptionLabel(["ecoConsumptionNotRelevant"]);

    return (
        <>
            {title && <h4 className={styles.title}>{title}</h4>}
            {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
            <dl className={styles.list}>
                <dt>{primary.label}</dt>
                <dd>
                    {(typeof primary.data === "string" ? primary.data : primary.data?.value) ||
                        ecoConsumptionNotRelevantLabel}
                    {typeof primary.data !== "string" && primary.data?.tooltip}
                </dd>
                <dt>{secondary.label}</dt>
                <dd>
                    {(typeof secondary.data === "string" ? secondary.data : secondary.data?.value) ||
                        ecoConsumptionNotRelevantLabel}
                    {typeof secondary.data !== "string" && secondary.data?.tooltip}
                </dd>
            </dl>
        </>
    );
};
